// extracted by mini-css-extract-plugin
export default {"container":"RedirectPage_container__DHx8v"};